function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesCac18Cinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#263238",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.667 0c-37.063 0-71.875 14.427-98.042 40.615l-192 192C14.437 258.812 0 293.635 0 330.667c0 76.458 62.208 138.667 138.667 138.667 37.063 0 71.875-14.427 98.042-40.615l192-191.99c26.188-26.198 40.625-61.021 40.625-98.063C469.333 62.208 407.125 0 330.667 0M221.625 413.635C199.479 435.792 170.021 448 138.667 448c-64.688 0-117.333-52.635-117.333-117.333 0-31.333 12.208-60.802 34.375-82.969l88.458-88.458 165.919 165.94zm192-191.989-88.456 88.45-165.919-165.94 88.458-88.458c22.146-22.156 51.604-34.365 82.958-34.365C395.354 21.333 448 73.969 448 138.667c0 31.343-12.208 60.812-34.375 82.979",
    style: {
      fill: "#263238",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "scale(.12784)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.792 198.792-64 63.99c-18.146 18.135-28.125 42.24-28.125 67.885a10.66 10.66 0 0 0 10.667 10.667 10.66 10.66 0 0 0 10.667-10.667c0-19.938 7.771-38.698 21.875-52.802l64-63.99c4.167-4.167 4.167-10.917 0-15.083-4.168-4.167-10.918-4.167-15.084 0",
    style: {
      fill: "#263238",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "scale(.12784)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesCac18Cinza);
export default __webpack_public_path__ + "static/media/Icones_cac_18_cinza.771ebe08a6bafd2d47b6fe520ba266f3.svg";
export { ForwardRef as ReactComponent };